import { useDispatch, useSelector } from 'react-redux';
import { TABLE_GRID } from 'modules/jobManager/constants';
import { useJobManagerTranslations } from 'modules/jobManager/hooks';
import { getJobManagerColumnData } from 'modules/jobManager/utils';
import { setJobTableSortBy, setJobTableSortDirection } from 'modules/jobManager/ducks/actions';
import { getJobManagerTableSort } from 'modules/jobManager/ducks/selectors';
import { JOBS_TABLE_COLUMNS } from 'modules/jobManager/types';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { HeaderRowCell } from './HeaderRowCell';

export const TableHeader = () => {
  const { t } = useJobManagerTranslations();
  const dispatch = useDispatch();
  const columns = getJobManagerColumnData(t);
  const { sortBy, sortDirection } = useSelector(getJobManagerTableSort);

  return (
    <HeaderGridRow gridLayout={TABLE_GRID}>
      {columns.map((column) => (
        <HeaderRowCell
          column={column}
          key={column.id}
          isActiveSortColumn={column.id === sortBy}
          sortDirection={sortDirection}
          setSortDirection={(direction: SORT_DIRECTIONS) =>
            dispatch(setJobTableSortDirection(direction))
          }
          setSortedBy={(col: JOBS_TABLE_COLUMNS) => dispatch(setJobTableSortBy(col))}
        />
      ))}
      <div data-test="placeholder-column-for-action-button" />
    </HeaderGridRow>
  );
};
